<template>
  <div>
    <div class="government-service">
      <template v-if="currentMode == 'list'">
        <div class="header-banner">
          <div class="header-overlay">
            <p class="header-overlay_title">政务服务</p>
            <div class="search-box">
              <el-input
                v-model="searchText"
                placeholder="搜索服务"
                clearable
                @input="handleSearch"
              >
                <template #prefix>
                  <el-icon><search /></el-icon>
                </template>
              </el-input>
            </div>
          </div>
        </div>

        <div class="quick-service">
          <div class="service-header">
            <h2>快捷服务入口</h2>
            <div
              class="view-more"
              @click="toggleShowAll"
              v-show="filteredServices.length > 6"
            >
              {{ showAll ? '收起' : '展开' }}
              <el-icon><arrow-right /></el-icon>
            </div>
          </div>
          <div class="service-scroll-container">
            <div
              class="service-container"
              :class="{ 'show-all': showAll }"
              v-if="filteredServices.length"
            >
              <div
                class="service-item"
                v-for="(item, index) in displayServices"
                :key="index"
                @click="handleServiceClick(item)"
              >
                <div class="service-icon">
                  <img
                    v-if="item.imageUrl"
                    :src="imgBasrUrl + item.imageUrl"
                    class="avatar"
                  />
                  <el-icon v-else class="el-icon-question"></el-icon>
                </div>
                <div class="service-content">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.subtitle }}</p>
                </div>
              </div>
            </div>
            <div v-else class="no-data">暂无对应数据</div>
          </div>
        </div>
      </template>
      <template v-if="currentMode == 'detail'">
        <div class="government-service-detail">
          <div class="government-header_banner">
            <p class="detail-overlay_title">政务服务详情</p>
          </div>
          <div class="detail-header">
            <p class="back" @click="backTo">
              <i class="el-icon-arrow-left"></i> 返回
            </p>
            <el-button
              v-if="openLinkUrl"
              type="text"
              class="external-link"
              @click="handleGetExternalLink"
            >
              点击跳转外部链接
            </el-button>
          </div>
          <div class="detail-content">
            <h1 class="title">{{ detailData?.title }}</h1>

            <!-- <div class="meta-info">
              <span class="date">{{ detailData?.gmtCreated }}</span>
            </div> -->
            <div class="title-image" v-if="detailData.coverImage">
              <el-image
                :src="imgBasrUrl + detailData.coverImage"
                fit="cover"
                :preview-src-list="[detailData.coverImage]"
              >
                <div slot="error" class="image-error">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <div class="content-text" v-html="detailData?.content"></div>
          </div>
        </div>
      </template>
    </div>
    <bottom-url />
  </div>
</template>

<script>
import BottomUrl from '@/components/bottomUrl/bottomUrl.vue';

import {
  Search,
  Money,
  Car,
  Refresh,
  Notebook,
  Iphone,
  Document,
  ArrowRight,
} from '@element-plus/icons-vue';
import {
  getServicesEntryList,
  getServiceContent,
} from '@/API/goverment/goverment.js';

export default {
  components: {
    Search,
    Money,
    Car,
    Refresh,
    Notebook,
    Iphone,
    Document,
    ArrowRight,
    BottomUrl,
  },
  data() {
    return {
      imgBasrUrl: process.env.VUE_APP_BASE_URL,
      searchText: '',
      showAll: false, // 默认不展开全部（超过4个时显示前4个）
      services: [],
      currentMode: 'list', // 当前页面模式
      detailData: {},
      openLinkUrl: '', // 跳转的链接
    };
  },
  created() {
    this.getEntryList();
    
    // 新增：检查是否有从全局搜索跳转过来的关键词
    const globalKeyword = sessionStorage.getItem('search_keyword_from_global');
    if (globalKeyword) {
      this.searchText = globalKeyword;
      sessionStorage.removeItem('search_keyword_from_global');
      // 有搜索关键词时自动展开全部
      this.showAll = true;
    }
  },
  computed: {
    filteredServices() {
      if (!this.searchText) {
        return this.services;
      }
      return this.services.filter((service) =>
        service.title.includes(this.searchText),
      );
    },
    // 根据折叠/展开状态显示的服务列表
    displayServices() {
      if (this.showAll) {
        return this.filteredServices;
      }
      // 折叠时只显示前4个
      return this.filteredServices.slice(0, 6);
    },
  },
  methods: {
    handleSearch() {
      if (this.searchText) {
        // 有搜索关键词时自动展开全部
        this.showAll = true;
      } else {
        // 清空搜索时，重置为折叠状态（如果服务数大于4）
        this.showAll = false;
      }
    },
    toggleShowAll() {
      this.showAll = !this.showAll;
    },
    handleServiceClick(service) {
      this.openLinkUrl = service.linkUrl;
      console.log('入口详情', service);
      if (service.linkParams && service.linkParams.articleId) {
        this.currentMode = 'detail';
        getServiceContent(service.linkParams.articleId).then((res) => {
          if (res.code == 200) {
            if (res.data) {
              this.detailData = res.data;
            } else {
              this.$set(this, 'detailData', {});
            }
          }
          console.log('文章详情', res, this.detailData);
        });
      } else {
        if (this.openLinkUrl) {
          window.open(this.openLinkUrl);
        } else {
          this.$message.warning('没有可跳转的链接或文章');
        }
      }
      console.log('点击服务:', service.title);
      // 这里可以添加跳转逻辑
    },
    getEntryList() {
      getServicesEntryList().then((res) => {
        console.log('获取快捷服务入口', res);
        if (res.code == 200 && res.data && res.data.length) {
          if (res.data[0].contents && res.data[0].contents.length) {
            this.services = res.data[0].contents.filter(
              (item) => item.status == 0,
            );
          } else {
            this.services = [];
          }
          // 初始状态：如果服务数量小于等于4，直接展示全部；否则折叠显示前4个
          this.showAll = this.services.length <= 4;
        } else {
          this.services = [];
          this.$message.error(res.message);
        }
      });
    },
    backTo() {
      this.currentMode = 'list';
    },
    // 跳转外部链接
    handleGetExternalLink() {
      if (!this.openLinkUrl) {
        this.$message.warning('没有可跳转的链接');
        return;
      }
      window.open(this.openLinkUrl);
    },
  },
};
</script>

<style scoped lang="less">
.government-service {
  max-width: 1200px;
  margin: 0 auto 60px;
  font-family: 'Microsoft YaHei', sans-serif;
}

.header-banner {
  background-image: url('../../../assets/recycling/componyImages/serveBackimg.png');
  background-size: cover;
  background-position: center;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 40px;
}

.header-overlay {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 90px;
  padding: 20px;
  box-sizing: border-box;
}

.header-overlay_title {
  font-size: 36px;
  color: #fff;
  align-self: flex-start;
  margin-left: 50px;
  color: black;
  font-weight: 400;
  margin-bottom: 40px;
}

.search-box {
  width: 60%;
  min-width: 300px;
}

.quick-service {
  margin-top: 30px;
  padding: 0 20px;
}

.service-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.service-header h2 {
  font-size: 22px;
  color: #333;
  margin: 0;
}

.view-more {
  color: #1890ff;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.view-more:hover {
  text-decoration: underline;
}

.view-more .el-icon {
  margin-left: 5px;
  transition: transform 0.3s;
}

.view-more:hover .el-icon {
  transform: translateX(3px);
}

/* 滚动容器样式 */
.service-scroll-container {
  height: 244px; /* 固定高度，超过时显示滚动条 */
  overflow-y: auto;
  padding-bottom: 20px;
}

.service-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  transition: all 0.3s ease;
}

/* 当处于折叠状态且内容超过4个时，通过 CSS 限制高度来保证只显示前4个 */
.service-container:not(.show-all) {
  max-height: calc((100px + 20px) * 2); /* 约等于2行服务项的高度 */
  overflow: hidden;
}

.service-container.show-all {
  max-height: none;
  overflow: visible;
}

.no-data {
  text-align: center;
  color: #999;
  font-size: 14px;
  padding: 20px;
  margin: 10px 0;
  background: #f9f9f9;
  border-radius: 4px;
}

.service-item {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #eee;
}

.service-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  background-color: #f0f7ff;
}

.service-icon {
  width: 50px;
  height: 50px;
  background-color: #e6f7ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  color: #1890ff;
  font-size: 24px;
  & > img {
    width: 36px;
  }
}

.service-content h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 5px;
}
.service-content {
  max-width: 266px;
}
.service-content p {
  font-size: 14px;
  color: #666;
  margin: 0;
}

/* 滚动条样式 */
.service-scroll-container::-webkit-scrollbar {
  width: 6px;
}

.service-scroll-container::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 3px;
}

.service-scroll-container::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

@media screen and (max-width: 768px) {
  .government-service{
    max-width: 100% !important;
  }
  .search-box {
    width: 80%;
  }

  .service-container {
    grid-template-columns: repeat(2, 1fr);
  }

  .header-banner {
    height: 160px !important;
    margin-top: 0 !important;
  }
  .header-overlay{
    margin-top: 0 !important;
    height: unset !important;
  }
  .service-header h2 {
    font-size: 18px !important;
  }
  .service-scroll-container{
    max-height: unset !important;
  }
  .service-item{
    display: unset !important;
    padding: 10px !important;
  }
  .service-icon {
    width: 50px !important;
    height: 50px !important;
    background-color: unset !important;
    border-radius: unset !important;
    display: unset !important;
    align-items: unset !important;
    justify-content: unset !important;
    margin-right: 15px;
    color: #1890ff;
    font-size: 24px;
    & > img {
      width: 50px !important;
    }
  }
  .service-content{
    max-width: 100% !important;
    h3{
      margin: 5px 0 !important;
    }
  }
}

@media (max-width: 480px) {
  .service-container {
    grid-template-columns: repeat(2, 1fr);
  }

  .header-overlay_title {
    font-size: 28px !important;
    margin-bottom: 10px !important;
  }

  .header-banner {
    height: 160px !important;
    margin-top: 0 !important;
  }
  .header-overlay{
    height: unset !important;
    margin-top: 0 !important;
  }
  .search-box {
    width: 90%;
    min-width: auto;
  }
  .service-header h2 {
    font-size: 18px !important;
  }
  .service-scroll-container{
    max-height: unset !important;
  }
  .service-item{
    display: unset !important;
    padding: 10px !important;
  }
  .service-icon {
    width: 50px !important;
    height: 50px !important;
    background-color: unset !important;
    border-radius: unset !important;
    display: block !important;
    align-items: unset !important;
    justify-content: unset !important;
    margin-right: 15px;
    color: #1890ff;
    font-size: 24px;
    & > img {
      width: 50px;
    }
  }
  .service-content{
    max-width: 100% !important;
    h3{
      font-size: 14px !important;
      margin: 5px 0 !important;
    }
  }
  .service-content p {
    font-size: 14px !important;
  }
}
// 颜色变量
@primary-color: #303133;
@secondary-color: #606266;
@info-color: #909399;
@border-color: #ebeef5;
@shadow-color: rgba(0, 0, 0, 0.1);
@white: #fff;
@error-color: #f56c6c;

// 字体大小
@font-size-base: 14px;
@font-size-large: 16px;
@font-size-title: 22px;
@font-size-header: 18px;

// 间距
@padding-base: 20px;
@padding-small: 15px;
@padding-mini: 10px;
@margin-base: 20px;
@margin-small: 15px;
@margin-large: 25px;

// 圆角
@border-radius-base: 4px;

// 行高
@line-height-base: 1.5;
@line-height-content: 1.8;

// 图片尺寸
@title-image-height: 300px;

.government-service-detail {
  border-radius: @border-radius-base;
  .government-header_banner {
    background-image: url('../../../assets/recycling/componyImages/service-detail.png');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    margin: 40px auto;
    .detail-overlay_title {
      margin-top: 60px;
      color: #fff;
      align-self: flex-start;
      margin-left: 50px;
      color: black;
      font-size: 40px;
      font-weight: 400;
      letter-spacing: 0px;
    }
  }
  .detail-header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid @border-color;
    margin-bottom: @margin-base;
    padding-bottom: 10px;
    .back {
      display: flex;
      align-items: center;
      gap: 5px;
      cursor: pointer;
      color: #666;
      font-size: 16px;
      font-weight: 600;
      &:hover {
        color: #409eff;
      }
    }
    .external-link {
      padding: 0;
      border-radius: 28px;
      background: rgba(21, 173, 97, 1);
      color: #fff;
      font-size: 14px;
      padding: 4px 4px;
    }
  }

  .detail-content {
    padding: 0 @padding-mini;

    .title {
      font-size: 32px;
      color: @primary-color;
      margin: 0 0 @margin-small 0;
      line-height: @line-height-base;
      text-align: center;
    }

    // 新增标题图片样式
    .title-image {
      margin: @margin-base 0;
      height: @title-image-height;
      border-radius: @border-radius-base;
      overflow: hidden;
      background-color: #f5f7fa;
      display: flex;
      align-items: center;
      justify-content: center;

      .el-image {
        width: 100%;
        height: 100%;

        .image-error {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: @error-color;
          font-size: 40px;
          background-color: #f5f5f5;
        }
      }
    }

    .meta-info {
      text-align: center;
      margin-bottom: @margin-large;
      color: @info-color;
      font-size: 20px;

      .date {
        margin-right: @margin-small;
      }

      .external-link {
        padding: 0;
        font-size: @font-size-base;
      }
    }

    .content-text {
      font-size: @font-size-large;
      line-height: @line-height-content;
      color: @secondary-color;
      font-family: Hiragino Sans GB, MicroSoft YaHei;
      font-size: 24px; /* 16-18px 基础大小 */
      line-height: 1.6; /* 良好的行间距 */
      color: #333; /* 深灰色更易阅读 */
      text-align: justify; /* 两端对齐 */
      text-justify: inter-word; /* 单词间调整 */
      & ::v-deep p {
        margin: 0 0 @margin-small 0;
        text-justify: inter-word; /* 单词间调整 */
      }

      & ::v-deep img {
        max-width: 100%;
        display: block;
        margin: @padding-mini auto;
      }
      ::v-deep a:hover {
        color: #1da1f2;
      }
    }
  }
}
</style>